<template>
	<div>
		<h2 v-if="withCompanyName && customer">{{ companyName }}</h2>
		<div v-if="isAnonymous" class="font-weight-extra-bold color-primary mt-2">Du bleibst anonym!</div>
		<div class="mt-2">
			<div class="font-weight-bold">
				{{ isAnonymous ? 'Anonym von ' : 'Von ' }} <span class="color-primary">{{ customerName }}</span>
				verabschieden:
			</div>
			<div class="mt-2">
				{{ customerName }} erhält eine Nachricht, dass du nicht interessiert bist.
			</div>
			<!--<div class="mb-3">Wähle bitte aus:</div>
			<b-form-radio
				v-model="customerUninterestingType"
				name="customerUninterestingType"
				value="customer"
				@input="emitChangeEvent"
			>
				<div class="font-weight-extra-bold">
					{{ isAnonymous ? 'Anonym von ' : 'Von ' }} <span class="color-primary">{{ customerName }}</span>
					verabschieden, andere Jobs von <span class="color-primary">{{ companyName }}</span> mit anderen
					Ansprechpartnern oder Vorgesetzten sind möglich.
				</div>
				<div class="mt-2">
					{{ customerName }} erhält nur eine Nachricht, dass du nicht interessiert bist. Es werden in
					Zukunft keine Jobanfragen von {{ customerName }} angezeigt und du kannst nicht mehr von dieser
					Person kontaktiert werden. Aber: Jobvorschläge von anderen Personen von {{ companyName }} sind
					möglich. (Du kannst diese Auswahl später wieder ändern).
				</div>
			</b-form-radio>
			<b-form-radio
				v-model="customerUninterestingType"
				name="customerUninterestingType"
				value="company"
				class="mt-2"
				@input="emitChangeEvent"
			>
				<div class="font-weight-extra-bold">
					{{ isAnonymous ? 'Anonym von ' : 'Von ' }} <span class="color-primary">{{ companyName }}</span>
					vollständig verabschieden.
				</div>
				<div class="mt-2">
					Es werden dir in Zukunft keine Jobs von {{ companyName }} mehr angezeigt und du kannst von dort
					nicht mehr kontaktiert werden. (Du kannst diese Auswahl später wieder ändern)
				</div>
			</b-form-radio>-->
		</div>
		<div class="mt-2">
			Verabschiedete Jobs bzw. Unternehmen und Organisationen findest du links in der Navigation. Dort kannst du
			diese auch wieder freischalten, solltest du deine Meinung ändern.
		</div>
	</div>
</template>

<script>
export default {

	props: {
		customer: {
			type: Object,
			required: false,
		},
		isAnonymous: {
			type: Boolean,
			required: false,
			default: true,
		},
		withCompanyName: {
			type: Boolean,
			required: false,
			default: true,
		}
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		return {
			// customerUninterestingType: undefined,
		};
	},

	computed: {
		companyName ()
		{
			return this.customer?.companyName || 'dieser Firma';
		},
		customerName ()
		{
			return this.customer?.nameWithSalutation || 'der Person';
		},
		// dataValid ()
		// {
		// 	return isDefined(this.customerUninterestingType);
		// },
	},

	methods: {
		emitChangeEvent ()
		{
			// if (!this.dataValid)
			// {
			// 	this.$emit('input', undefined);
			// 	return;
			// }

			this.$emit('input', {
				customerUninterestingType: 'job-profile'
			});
		}
	}
}
</script>
